import React, { useState } from 'react';
import {
  Box, Button, TextField, Typography, CircularProgress, Alert
} from '@mui/material';
import { supabase } from './supabaseClient';
import { useNavigate } from 'react-router-dom';

export default function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const { error } = await supabase.auth.signInWithPassword({ email, password });
      if (error) throw error;
      navigate('/admin');
    } catch (err) {
      setError('Nesprávný e-mail nebo heslo.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{
      minHeight: '100vh',
      bgcolor: '#f8f9fa',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    }}>
      <Box
        component="form"
        onSubmit={handleLogin}
        sx={{
          bgcolor: 'white',
          p: 6,
          borderRadius: 4,
          boxShadow: '0 8px 40px rgba(0,0,0,0.08)',
          width: '100%',
          maxWidth: 400,
        }}
      >
        {/* Logo */}
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 5 }}>
          <svg width="32" height="32" viewBox="0 0 40 40" fill="none">
            <rect width="40" height="40" rx="10" fill="#0066FF"/>
            <path d="M26 13H16C14.3431 13 13 14.3431 13 16V24C13 25.6569 14.3431 27 16 27H26"
              stroke="white" strokeWidth="3.5" strokeLinecap="round" />
            <circle cx="28" cy="20" r="3" fill="white"/>
          </svg>
          <Typography sx={{ fontWeight: 900, fontSize: '1.4rem', letterSpacing: -1, color: '#000' }}>
            CRONET
          </Typography>
        </Box>

        <Typography variant="h6" sx={{ fontWeight: 800, mb: 0.5 }}>Přihlášení</Typography>
        <Typography variant="body2" sx={{ color: '#888', mb: 4 }}>
          Přístup pouze pro administrátory
        </Typography>

        {error && (
          <Alert severity="error" sx={{ mb: 3, borderRadius: 2 }}>{error}</Alert>
        )}

        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2.5 }}>
          <TextField
            label="E-mail"
            type="email"
            fullWidth
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            autoFocus
          />
          <TextField
            label="Heslo"
            type="password"
            fullWidth
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
          <Button
            type="submit"
            variant="contained"
            fullWidth
            size="large"
            disabled={loading}
            sx={{ py: 1.5, fontWeight: 700, borderRadius: 2, mt: 1 }}
          >
            {loading ? <CircularProgress size={22} color="inherit" /> : 'Přihlásit se'}
          </Button>
        </Box>
      </Box>
    </Box>
  );
}
